import Vue from 'vue'

export default function getStudents(id, schoolyear_id) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/students/" + id

    url += `?${new URLSearchParams({ schoolyear_id }).toString()}`

    return Vue.http
        .get(url, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
}